import React from 'react';
import SectionSettings from '../SectionSettings';

const AdminCouple = () => <SectionSettings sectionKey="couple" />;

export default AdminCouple;
